
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
@Injectable()

export class LoaderService {
  private loaderSubject = new Subject<boolean>();
  public loaderState = this.loaderSubject.asObservable();
  public isLoading: Observable<any>;

  constructor(
    private router: Router,
  ) {
    this.routeNavigationStart();
    // this.loaderViaStore();
  }

  // loaderViaStore(){

  //   this.isLoading.subscribe(data=>{
  //     if(data){
  //       if(data.isLoading){
  //           this.show();
  //       }else{
  //         this.hide();
  //       }
  //     }
  //   })

  // }


  show() {
    this.loaderSubject.next(true);
  }

  hide() {
    this.loaderSubject.next(false);
  }

  routeNavigationStart() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {

        this.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {

        this.hide();
      }
    });

  }


}
